import React from 'react';
import { Box, Typography, Stack, Switch } from '@mui/material';
import { translate as t } from 'hooks/useTranslations';
import { OrganizationTrainingConfig } from '../../../_types/training';

interface ViewProps {
  config: OrganizationTrainingConfig;
}

const View: React.FC<ViewProps> = ({ config }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Typography
        variant='subtitleSm'
        sx={{ mb: 1 }}
      >
        {t('manageSolutions.training.activeSubscriptions')}
      </Typography>
      <Stack spacing={2}>
        {config.modules.map((module) => {
          const isEnabled = module.status === 'ENABLED';
          return (
            <Box
              key={module.id}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 3,
              }}
            >
              <Switch
                checked={isEnabled}
                disabled
                color='success'
                size='xs'
              />
              <Typography
                variant='bodySm'
                sx={{ flex: 1 }}
              >
                {module.name}
              </Typography>
            </Box>
          );
        })}
      </Stack>
    </Box>
  );
};

export default View;
